<template>
  <div class="container have-footer mcontainer">
    <!--    <div class="flex-column justify-content-center align-items-center" style="height: 1.7rem">-->
    <!--      <i class="title">发现</i>-->
    <!--    </div>-->
    <top-bar :title="'发现'" :right-image="iconTopMap" @rightClick="rightClick">
    </top-bar>
    <div class="main-content-top0">
      <div style="background-color: #ffffff;padding-top: 0.2rem">
        <div class="search flex-row justify-content-start">
          <div
              class="search-left flex-column justify-content-center align-items-center"
          >
            <i class="el-icon-search"></i>
          </div>
          <div class="search-main flex-column justify-content-center">
            <input v-model="input" type="text" placeholder="请输入活动关键词"/>
            <!--          <el-input v-model="input" placeholder="请输入活动关键词"></el-input>-->
          </div>
          <div class="search-right">
            <div
                @click="searchActivityF"
                class="search-button flex-column justify-content-center align-items-center"
            >
              <i>活动搜索</i>
            </div>
          </div>
        </div>
      </div>
      <div style="background-color: #ffffff">
        <div class="tab">
          <div
              @click="check($event, item, index)"
              :to="item.index"
              class="flex-column justify-content-center align-items-center"
              :class="{ on: item.index === index }"
              v-for="(item, index) in typeList"
              :key="index"
          >
            <div class="tab-image">
              <img class="tab-image" :src="activityType[item.value]" alt=""/>
            </div>

            <div>
              <font>{{ item.label }}</font>
            </div>
            <div
                style="width: 100%;min-height: 2px;margin-top: 0.1rem"
                :style="{
                backgroundColor: count === index ? '#2b51ab' : '#ffffff'
              }"
            ></div>
          </div>
        </div>
      </div>
      <div
          v-for="(item, index) in activityList"
          :key="index"
          v-show="activitys[0]"
          style="background-color: #ffffff"
          class="flex-row item"
      >
        <div
            class="flex-column justify-content-center align-items-center"
            style="width: 40%"
        >
          <img
              :src="VUE_APP_API_URL + `/home/getImage?id=` + item.image"
              alt=""
              style="width: 100%"
          />
        </div>
        <div
            class="flex-column justify-content-start"
            style="padding-left: 10px;width: 100%"
        >
          <div class="flex-row align-items-center title">
            <i>{{ item.activityTitle }}</i>
          </div>
          <div class="flex-row align-items-center msg">
            <i class="el-icon-date" style="color: #6498EB"></i>
            <i style="margin-left: 10px">{{ item.beginDate?item.beginDate.substr(0, 10):"" }}</i>
          </div>
          <div class="flex-row align-items-center msg">
            <i class="el-icon-office-building" style="color: #6498EB"></i>
            <!--            <i style="margin-left: 10px"-->
            <!--               :href="'http://uri.amap.com/marker?position='+item.lng+','+item.lat+'&name=address&coordinate=gaode&callnative=1'">{{-->
            <!--                item.addr-->
            <!--              }}</i>-->
            <!--          :href="
                'http://uri.amap.com/marker?position=' +
                  item.longitude +
                  ',' +
                  item.latitude +
                  '&name=' +
                  item.addr +
                  '&coordinate=gaode&callnative=1'
              " -->
            <!--            <el-link-->
            <!--              style="margin-left: 10px;max-lines: 1"-->
            <!--              type="primary"-->
            <!--            >-->
            <!--              <template>-->
            <!--                <span>{{ item.addr }}</span>-->
            <!--              </template>-->
            <!--            </el-link>-->
            <i style="margin-left: 10px;max-lines: 1">
              {{ item.addr }}
            </i>
          </div>
          <div class="flex-row justify-content-start">
            <div
                class="flex-column justify-content-start"
                style="width: calc(100% - 1.4rem)"
            >
              <div class="flex-row align-items-center msg">
                <i class="el-icon-time" style="color: #6498EB"></i>
                <i style="margin-left: 10px">
                  {{ item.endDate?item.endDate.substr(0, 10):"" }}</i
                >
              </div>
              <div class="flex-row align-items-center msg">
                <i class="el-icon-time" style="color: #6498EB"></i>
                <i style="margin-left: 10px">{{ item.count }}人报名</i>
              </div>
            </div>
            <div
                style="width:1.4rem;height:0.4rem;"
                class="flex-column justify-content-center align-items-center search-button"
                @click="mSignUp($event, item)"
                :style="{
                background: initBackgroud(item)
              }"
            >
              <i>{{ initValue(item) }}</i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
        style="position: fixed;z-index: 888;background-color: #000000E0;top: 0"
        v-if="showMap"
    >
      <div class="flex-column">
        <left-top-bar :title="'活动地图'" @back="back" :is-back="false"></left-top-bar>
        <map-activity></map-activity>
      </div>
    </div>
  </div>
</template>

<script>

import {getActivity, getDicts, signUp, searchActivity} from "@/api/home";
import {VUE_APP_API_URL} from "@utils";
import topBar from "../top-bar/index2";
import leftTopBar from "../top-bar";
import top from "@/assets/home_new/onTheGo/top.png";
import iconTopMap from "@/assets/home_new/activity/iton-top-map.png";
import A from "@/assets/home_new/find/A.png";
import B from "@/assets/home_new/find/B.png";
import C from "@/assets/home_new/find/C.png";
import D from "@/assets/home_new/find/D.png";
import E from "@/assets/home_new/find/E.png";
import mapActivity from "./map-activity.vue";
import test1 from "@/assets/home_new/find/test1.png";

export default {
  name: "find",
  components: {
    topBar,
    mapActivity,
    leftTopBar
  },
  data() {
    return {
      activityType: {
        A: A,
        B: B,
        C: C,
        D: D,
        E: E
      },
      showMap: false,
      showSms: true,
      VUE_APP_API_URL: VUE_APP_API_URL,
      test1: test1,
      iconTopMap: iconTopMap,
      route: {},
      top: top,
      count: 0,
      input: "",
      typeList: [],
      activityList: undefined,
      activitys: [],
      checkTime: true
    };
  },
  created() {
    this.route = this.$route.query;
    this.initDicts();
    this.initData();
  },
  mounted() {
  },
  destroyed() {
  },
  methods: {
    initBackgroud(item) {
      if (item.registeredCount > 0)
        return "linear-gradient(to right, #7EEC63, #008302)";
      if (item.ended) return "linear-gradient(to right, #808080, #808080";
      else return "linear-gradient(to right, #0cb1fe, #0e74ff)";
    },
    initValue(item) {
      if (item.registeredCount > 0) return "已报名";
      return item.ended ? "已结束" : "报名中";
    },
    rightClick() {
      this.showMap = true;
    },
    back() {
      this.showMap = false;
    },
    mSignUp($event, item) {
      this.$router.push({path: "/second_level?id="+item.activityId});
    },
    initDicts() {
      var _this = this;
      getDicts({dictName: "activity_type"})
          .then(res => {
            console.info(res);
            _this.typeList = res;
          })
          .catch(e => {
            console.info(e);
            _this.$message.error("网络请求异常!" + e);
          });
    },
    initData() {
      var _this = this;
      getActivity({})
          .then(res => {
            console.info(res);
            _this.activitys[0] = res;
            _this.activityList = _this.activitys[0]["A"];
          })
          .catch(e => {
            console.info(e);
            _this.$message.error("网络请求异常!" + e);
          });

    },
    searchActivityF() {
      if (!this.checkTime) {
        this.$message.error("搜索太频繁,请稍后再试");
        return;
      }
      this.checkTime = false;
      //1秒后重置 才能继续搜索  防止一直点
      setTimeout(e => {
        this.checkTime = true;
      }, 3000);


      var _this = this;
      searchActivity({title: this.input})
          .then(res => {
            console.info(res);
            _this.activitys[0] = res;
            for (var this1 in _this.typeList) {
              if (_this.activitys[0][_this.typeList[this1].value]) {
                _this.activityList = _this.activitys[0][_this.typeList[this1].value];
                _this.count = parseInt(this1)
                return
              }
            }
          })
          .catch(e => {
            console.info(e);
            _this.$tip({
              show: true,
              message: e.message
            });
          });
    },
    check(event, item, index) {
      this.count = index;
      this.activityList = this.activitys[0][item.value];
    }
  }
};
</script>

<style scoped>
@import "../../assets/css/flex.css";
@import "../../assets/css/font-title.css";
@import "../../assets/css/msg.css";

.mcontainer {
  overflow: hidden;
  background-color: #eeeeee;
}

.search {
  border-radius: 0.1rem;
  border-width: 1px;
  border-style: solid;
  border-color: #2f78df;
  background-color: #ffffff;
  color: #0ba6fa;
  margin: 0 0.33rem 0 0.33rem;
}

.search-left {
  width: 0.7rem;
  font-size: 0.4rem;
}

.search-main {
  width: calc(100% - 1.8rem);
  font-size: 0.24rem;
}

.search-right {
  width: 1.9rem;
}

.search-button {
  height: calc(100% - 0.2rem);
  width: calc(100% - 0.2rem);
  margin: 0.1rem;
  text-align: center;
  font-size: 0.28rem;
  color: #ffffff;
  background: linear-gradient(to right, #0cb1fe, #0e74ff);
  border-radius: 0.1rem;
}

.tab {
  width: 100%;
  margin-top: 0.2rem;
  /*// padding: .86rem 0 .66rem 0;*/
  /*// background-color: #007aff50;*/
  display: grid;
  /*  声明了三列，宽度分别为 200px 100px 200px */
  grid-template-columns: repeat(5, 1fr);
  /*// grid-template-columns: repeat(auto-fill, 49%)*/
  grid-gap: 0.2rem;
  /*  声明了两行，行高分别为 50px 50px  */
  /*// grid-template-rows: 47% 47%;*/
  grid-template-rows: 100%;
}

.tab-image {
  font-size: 0.45rem;
  width: 1.2rem;
  height: 1.2rem;
}

.item {
  padding: 0.1rem 0.33rem 0.1rem 0.33rem;
  margin-top: 0.1rem;
}
</style>
